import React, { createContext, useContext, useMemo } from 'react';
import { resolveBrand, DEFAULT_BRAND } from '@/config/brand';
import type { BrandConfig } from '@/config/brand';

const BrandContext = createContext<BrandConfig>(DEFAULT_BRAND);

export const BrandProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const brand = useMemo(() => resolveBrand(), []);
  console.log('brand', brand);
  React.useEffect(() => {
    console.log('brand',brand.title, brand.logo)
    document.title = brand.title;
    // 仅当品牌 logo 与默认品牌不同时才替换 favicon
    if (brand.logo !== DEFAULT_BRAND.logo) {
      const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (link) link.href = brand.logo;
    }
  }, [brand.title, brand.logo]);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
};

export const useBrand = (): BrandConfig => useContext(BrandContext);
